import React, { Component } from "react";
import RecipesList from "../components/RecipesList";
import RecipeSearch from "../components/RecipeSearch";

const apiKey = process.env.REACT_APP_API;
export default class Recipes extends Component {
  state = {
    recipes: [],
    term: "",
  };

  handleChange = (event) => {
    this.setState({
      term: event.target.value,
    });
  };

  findRecipe = (event) => {
    event.preventDefault();
    const { term } = this.state;
    if (term) {
      const apiUrl = `https://api.spoonacular.com/recipes/complexSearch?apiKey=${apiKey}&query=${term}&addRecipeInformation=true&number=30`;

      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            recipes: data.results,
          });
        });
    }
  };

  componentDidMount() {
    const recipes = JSON.parse(localStorage.getItem("recipes"));
    const term = JSON.parse(localStorage.getItem("term"));
    console.log(recipes);
    if (recipes) {
      this.setState({
        recipes,
        term,
      });
    }
  }

  componentDidUpdate() {
    const recipes = JSON.stringify(this.state.recipes);
    const term = JSON.stringify(this.state.term);
    localStorage.setItem("recipes", recipes);
    localStorage.setItem("term", term);
  }

  render() {
    const { recipes, term } = this.state;
    return (
      <>
        <RecipeSearch
          handleChange={this.handleChange}
          findRecipe={this.findRecipe}
        />

        {term === "" ? (
          <h1 className="search-heading">Search a new recipe..</h1>
        ) : (
          <RecipesList recipes={recipes} />
        )}
      </>
    );
  }
}
